import { render, staticRenderFns } from "./TwoFactorAuth.vue?vue&type=template&id=c6d5856a"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuth.vue?vue&type=style&index=0&id=c6d5856a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports